import { BlogArchive } from "@features/blog/BlogArchive"
import { defineView } from "eddev/views"

export default defineView("archive-blog", (props) => {
  return <BlogArchive {...props} />
})
